<script setup>

import {getGeographicMidpoint} from '~/utils/mapUtils'

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const defaultOptions = {
  title: 'Mapa',
  width: '100%',
  height: '350px',
  zoom: 15
}

const loaded = ref(false)
const options = ref({...defaultOptions})
const mapRef = ref()
const mapCenter = ref([37.389091, -5.984459])
const blockContent = computed(() => props.data?.content || null)
const hasLocation = computed(() => blockContent.value?.items?.length > 0)
const haveVSpacing = computed(() => blockContent.value.vSpacing)
const areaPointList = computed(() => blockContent.value.items.map(item => [parseFloat(item.lat), parseFloat(item.lng)]))
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'mt-3': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})

function getGeoObj(location) {
  return [parseFloat(location.lat.split(',')[0]), parseFloat(location.lng.split(',')[0])]
}

onMounted(() => {
  mapCenter.value = getGeographicMidpoint(areaPointList.value)
  loaded.value = true
})
</script>

<template>
  <div v-if="blockContent"
       class="col-span-grid grid-cols-12"
       :class="containerClasses">
    <ClientOnly fallback-tag="div" fallback="Cargando mapa...">
      <LMap
        v-if="loaded"
        ref="mapRef"
        :zoom="options.zoom"
        :show-map="hasLocation"
        :use-global-leaflet="false"
        :style="{height: options.height, width: options.width}"
        :center="mapCenter"
      >
        <LTileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&amp;copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors"
          layer-type="base"
          name="OpenStreetMap"
        >
        </LTileLayer>
        <LMarker v-for="location in blockContent.items" :key="location.id" :lat-lng="getGeoObj(location)">
          <LIcon icon-url="/img/maps/marker.png" :icon-size="[30, 50]"/>
          <LPopup>
            <h4>{{ location.title }}</h4>
            <div v-if="location.description" v-html="location.description"></div>
          </LPopup>
        </LMarker>
      </LMap>
    </ClientOnly>
  </div>
</template>
